import { FIELDS_USING_ID } from '@api/instant_survey/utilities/constants';

/**
 * Transforms prompt answers for API submission.
 * @param {Array} promptAnswers - The array of prompt answers to transform.
 * @returns {Array} Transformed prompt answers ready for API submission.
 */
export const transformPromptAnswers = (promptAnswers) => {
  return promptAnswers.map(({ field, fieldType, id, operator, promptId, values }) => {
    let value;
    let insightsValues;

    if (fieldType === 'COMPARISON_PERIOD') {
      const comparisonPeriod = values?.[0];
      insightsValues = [{ name: comparisonPeriod }];
      value = comparisonPeriod;
    } else if (fieldType === 'DATE') {
      const dateRange = Array.isArray(values?.date_range) ? values.date_range : values;
      value = dateRange?.join(';');
      insightsValues = dateRange;
    } else {
      insightsValues = values;
      const filterCondition = (value) => value !== undefined && value !== null;
      value =
        Array.isArray(values) && values.length > 0
          ? values
              .map((value) =>
                typeof value === 'object'
                  ? FIELDS_USING_ID.includes(field)
                    ? value.id
                    : value.name
                  : value
              )
              .filter(filterCondition)
              .join(';')
          : '';
    }
    return {
      fe_notes: { insights_values: insightsValues },
      field,
      field_type: fieldType,
      id,
      operator,
      prompt_id: promptId,
      value,
    };
  });
};
